export const sparePartsList = "SPARE_PART_LIST";
